import React from "react";
import { Box } from "@chakra-ui/react";

interface VimeoEmbedProps {
  videoId: string;
  title?: string;
}

export const VimeoEmbed = ({
  videoId,
  title = "Vimeo video",
}: VimeoEmbedProps) => {
  return (
    <Box mb={4}>
      <div style={{ padding: "54.93% 0 0 0", position: "relative" }}>
        <iframe
          src={`https://player.vimeo.com/video/${videoId}?badge=0&autopause=0&player_id=0&app_id=58479`}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          title={title}
        />
      </div>
      <script src="https://player.vimeo.com/api/player.js" />
    </Box>
  );
};
